import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import ModulesTable from "./ModulesTable";
import BonusPaymentModule from "./BonusPaymentModule";
import TimerConfigurationModule from "./TimerConfigurationModule";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { useContext, useEffect, useState } from "react";
import { ConfigProvider, DatePicker } from "antd";
import ptBR from "antd/lib/locale/pt_BR";
import { useNavigate } from "react-router-dom";
// ModulesTable component imports moment directly, so we don't need it here

const ModalRelatorio = ({ isOpen, onClose, selectedId, maquinasInfo }) => {
  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");

  const [pagamentos, setPagamentos] = useState(null);

  // Using useNavigate hook
  const navigate = useNavigate();

  const { authInfo, setDataUser, setNotiMessage } = useContext(AuthContext);
  const token = authInfo?.dataUser?.token;
  const { dataUser } = authInfo;


  useEffect(() => {
    const getData = async () => {
      try {
        const res = await axios.get(
          dataUser.key === "ADMIN"
            ? `${process.env.REACT_APP_SERVIDOR}/pagamentos-adm/${selectedId}`
            : `${process.env.REACT_APP_SERVIDOR}/pagamentos/${selectedId}`,
          {
            headers: {
              "x-access-token": token,
              "content-type": "application/json",
            },
          }
        );
        if (res.status === 200) {
          setPagamentos(res.data);
        }
      } catch (err) {
        if ([401, 403].includes(err.response?.status)) {
          setNotiMessage({
            type: "error",
            message:
              "A sua sessão expirou, para continuar faça login novamente.",
          });
          setDataUser(null);
        }
      }
    };

    getData();
  }, [selectedId, setDataUser, token, setNotiMessage, dataUser.key]);

  const pagamentosFiltrados = pagamentos?.pagamentos.filter((pagamento) => {
    const dataPagamento = new Date(pagamento.data); // Converte a data do pagamento
    const inicio = new Date(dataInicio); // Converte `dataInicio`
    const fim = new Date(dataFim); // Converte `dataFim`

    // Verifica se a data do pagamento está entre `dataInicio` e `dataFim`
    return dataPagamento >= inicio && dataPagamento <= fim;
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        backgroundColor="#1a202c"
        style={{ width: "250px", height: "250px" }}
      >
        <ModalCloseButton color="white" />
        <ModalBody style={{ marginTop: "50px" }}>
          <ConfigProvider locale={ptBR}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  htmlFor="data-inicial"
                  style={{ marginBottom: "8px", color: "white" }}
                >
                  Data Inicial
                </label>
                <DatePicker
                  id="data-inicial"
                  style={{
                    border: "1px solid #1F2630",
                    borderRadius: "4px",
                    width: "100%",
                    backgroundColor: "transparent",
                    color: "white",
                  }}
                  showTime={{ format: "HH:mm" }}
                  format="YYYY-MM-DD HH:mm"
                  placeholder="Selecione a data e hora"
                  onChange={(date, dateString) => {
                    setDataInicio(dateString || null);
                  }}
                  getPopupContainer={(trigger) => trigger.parentElement}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginTop: "8px",
                }}
              >
                <label
                  htmlFor="data-final"
                  style={{ marginBottom: "8px", color: "white" }}
                >
                  Data Final
                </label>
                <DatePicker
                  id="data-final"
                  style={{
                    border: "1px solid #1F2630",
                    borderRadius: "4px",
                    width: "100%",
                    backgroundColor: "transparent",
                  }}
                  showTime={{ format: "HH:mm" }}
                  format="YYYY-MM-DD HH:mm"
                  placeholder="Selecione a data e hora"
                  onChange={(date, dateString) =>
                    setDataFim(dateString || null)
                  }
                  getPopupContainer={(trigger) => trigger.parentElement}
                />
              </div>
              <Button
                marginTop="8px"
                fontSize="14px"
                onClick={() => {
                  if (dataInicio && dataFim) {
                    navigate(`/relatorio-cliente/${selectedId}`, {
                      state: {
                        dataInicio,
                        dataFim,
                        maquinaInfos: {
                          nome: maquinasInfo.nome,
                          id: maquinasInfo.id,
                        },
                        totalVendas: pagamentosFiltrados.length,
                      },
                    });
                  }
                }}
              >
                Gerar relátorio
              </Button>
            </div>
          </ConfigProvider>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

const ModalModuleEdit = ({ isOpen, onClose, moduleProps = {} }) => {
  const [moduleInfo, setModuleInfo] = useState(moduleProps);

  const toast = useToast();

  console.log("MODULE INFO", moduleInfo);

  const { authInfo } = useContext(AuthContext);
  const token = authInfo?.dataUser?.token;
  const { dataUser } = authInfo;

  const onSave = async () => {
    try {
      await axios
        .put(
          dataUser.key === "ADMIN"
            ? `${process.env.REACT_APP_SERVIDOR}/maquina-adm`
            : `${process.env.REACT_APP_SERVIDOR}/maquina-cliente`,
          {
            id: moduleInfo.id,
            nome: moduleInfo.nome,
            descricao: moduleInfo.descricao,
            estoque: Number(moduleInfo.estoque),
            store_id: String(moduleInfo.store_id),
            maquininha_serial: moduleInfo.maquininha_serial,
            pos: moduleInfo.pos,
          },
          {
            headers: {
              "x-access-token": token,
              "content-type": "application/json",
            },
          }
        )
        .then((res) => {
          toast({
            title: "Módulo salvo com sucesso",
            status: "success",
            duration: 2000,
            isClosable: true,
          });
          onClose();
          //window.location.reload();
        });
    } catch (error) {
      console.log(`Erro ao salvar as alterações do modulo. ${error}`)
      toast({
        title: "Erro ao salvar as alterações do módulo",
        status: "error",
        duration: 2000,
        isClosable: true,
      });
    }
  };


  useEffect(() => {
    setModuleInfo(moduleProps);
  }, [moduleProps]);
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent backgroundColor="#1a202c">
        <ModalCloseButton color="white" />
        <ModalBody style={{ marginTop: "50px" }}>
          <form>
            <FormControl>
              <FormLabel color="white">Nome</FormLabel>
              <Input
                type="text"
                value={moduleInfo.nome}
                color="white"
                onChange={({ target }) =>
                  setModuleInfo((prev) => ({
                    ...prev,
                    nome: target.value,
                  }))
                }
              />
            </FormControl>
            {dataUser?.key === "ADMIN" ? (
              <FormControl marginTop="20px">
                <FormLabel color="white">Admin pos</FormLabel>
                <Input
                  type="text"
                  value={moduleInfo.pos}
                  color="white"
                  onChange={({ target }) =>
                    setModuleInfo((prev) => ({
                      ...prev,
                      pos: target.value,
                    }))
                  }
                />
              </FormControl>
            ) : (
              <></>
            )}

            <FormControl marginTop="20px">
              <FormLabel color="white">Loja</FormLabel>
              <Input
                type="text"
                value={moduleInfo.descricao}
                color="white"
                onChange={({ target }) =>
                  setModuleInfo((prev) => ({
                    ...prev,
                    descricao: target.value,
                  }))
                }
              />
            </FormControl>
            <FormControl marginTop="20px">
              <FormLabel color="white">Estoque</FormLabel>
              <Input
                type="text"
                value={moduleInfo.estoque}
                color="white"
                onChange={({ target }) =>
                  setModuleInfo((prev) => ({
                    ...prev,
                    estoque: target.value,
                  }))
                }
              />
            </FormControl>
            <FormControl marginTop="20px">
              <FormLabel color="white">Store ID</FormLabel>
              <Input
                type="text"
                value={moduleInfo.store_id}
                color="white"
                onChange={({ target }) =>
                  setModuleInfo((prev) => ({
                    ...prev,
                    store_id: target.value,
                  }))
                }
              />
            </FormControl>
            <FormControl marginTop="20px">
              <FormLabel color="white">Maquininha Serial</FormLabel>
              <Input
                type="text"
                value={moduleInfo.maquininha_serial}
                color="white"
                onChange={({ target }) =>
                  setModuleInfo((prev) => ({
                    ...prev,
                    maquininha_serial: target.value,
                  }))
                }
              />
            </FormControl>
          </form>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" onClick={onClose} color="white">
            Cancelar
          </Button>
          <Button colorScheme="blue" mr={3} onClick={onSave}>
            Salvar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

const DeleteModal = ({ isOpen, onClose, id }) => {
  const { authInfo, setDataUser, setNotiMessage } =
    useContext(AuthContext);
  const token = authInfo?.dataUser?.token;
  const type = authInfo?.dataUser?.key;

  const deleteHandler = () => {
    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: type === 'ADMIN' ? 
      `${process.env.REACT_APP_SERVIDOR}/maquina-adm` 
      : `${process.env.REACT_APP_SERVIDOR}/maquina-cliente`,
      headers: {
        "x-access-token": token,
        "Content-Type": "application/json",
      },
      data: { id },
    };

    axios
      .request(config)
      .then((res) => {
        setNotiMessage({
          type: "success",
          message: "Deleted Successfully.",
        });
        onClose();
        window.location.reload();
      })
      .catch((err) => {
        if ([401, 403].includes(err.response.status)) {
          setNotiMessage({
            type: "error",
            message: "Delete Failed",
          });
          setDataUser(null);
        }
      });
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent backgroundColor="#1a202c">
        <ModalCloseButton color="white" />
        <ModalBody style={{ marginTop: "50px", textAlign: "center" }}>
          <Text fontSize="20px" color="white">
            Deseja excluir essa máquina?
          </Text>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" onClick={onClose} color="white">
            Cancelar
          </Button>
          <Button colorScheme="blue" mr={3} onClick={deleteHandler}>
            Excluir
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

const RemoteCreditModal = ({ isOpen, onClose, id }) => {
  const { authInfo, setDataUser, setNotiMessage } =
    useContext(AuthContext);
  const token = authInfo?.dataUser?.token;

  const [value, setValue] = useState(0);

  const addCredit = () => {
    axios
      .post(
        `${process.env.REACT_APP_SERVIDOR}/credito-remoto-cliente`,
        {
          id: id,
          valor: value,
        },
        {
          headers: {
            "x-access-token": token,
            "content-type": "application/json",
          },
        }
      )
      .then((res) => {
        setNotiMessage({
          type: "success",
          message: `${res?.data?.retorno}`,
        });
        onClose(); // Fecha o modal após o sucesso
      })
      .catch((err) => {
        if ([401, 403].includes(err.response.status)) {
          setNotiMessage({
            type: "error",
            message:
              "A sua sessão expirou, para continuar faça login novamente.",
          });
          setDataUser(null);
        } else {
          setNotiMessage({
            type: "error",
            message: `Erro, algo deu errado ${err.response?.data?.msg}`,
          });
        }
      });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent backgroundColor="#1a202c">
        <ModalCloseButton color="white" />
        <ModalBody style={{ marginTop: "50px", textAlign: "center" }}>
          <form>
            <FormControl>
              <FormLabel color="white">Valor</FormLabel>
              <Input
                type="number"
                value={value}
                color="white"
                onChange={({ target }) => setValue(target.value)}
              />
            </FormControl>
          </form>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" onClick={onClose} color="white">
            Cancelar
          </Button>
          <Button colorScheme="blue" mr={3} onClick={addCredit}>
            Adicionar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default function Modules() {
  const [modules, setModules] = useState([]);
  const [moduleProps, setModuleProps] = useState({});
  const [selectedId, setSelectedId] = useState(undefined);
  const [selectedMaquina, setSelectedMaquina] = useState({ nome: "" });
  const { authInfo } = useContext(AuthContext);
  const token = authInfo?.dataUser?.token;
  const { dataUser } = authInfo;

  const { onOpen, onClose, isOpen } = useDisclosure();
  const {
    onOpen: onOpenDeleteModal,
    onClose: onCloseDeleteModal,
    isOpen: isOpenDeleteModal,
  } = useDisclosure();
  const {
    onOpen: onOpenRemoteCreditModal,
    onClose: onCloseRemoteCreditModal,
    isOpen: isOpenRemoteCreditModal,
  } = useDisclosure();
  const {
    onOpen: onOpenModalRelatorio,
    onClose: onCloseModalRelatorio,
    isOpen: isOpenModalRelatorio,
  } = useDisclosure();
  const {
    onOpen: onOpenBonusPaymentModal,
    onClose: onCloseBonusPaymentModal,
    isOpen: isOpenBonusPaymentModal,
  } = useDisclosure();
  const {
    onOpen: onOpenTimerConfigModal,
    onClose: onCloseTimerConfigModal,
    isOpen: isOpenTimerConfigModal,
  } = useDisclosure();

  const dataData = () => {
    axios
      .get(
        dataUser.key === "ADMIN"
          ? `${process.env.REACT_APP_SERVIDOR}/maquinas-adm`
          : `${process.env.REACT_APP_SERVIDOR}/maquinas`,
        {
          headers: {
            "x-access-token": token,
            "content-type": "application/json",
          },
        }
      )
      .then((response) => {
        setModules(response.data);
      })
      .catch((error) => console.log("error", error));
  };

  useEffect(() => {
    dataData();

    const intervalId = setInterval(() => {
      dataData();
    }, 60000);

    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const availableModules = modules.filter(({ status }) => status && status !== "OFFLINE");
  const unavailableModules = modules.filter(module => {
    return module?.status === "OFFLINE" || !module?.status
  })

  return (
    <Flex minH="90vh" flexDirection="column">
      <Text color="white" fontSize="24px">
        Módulos
      </Text>
      <Tabs>
        <TabList borderColor="#1F2630">
          <Tab
            color="white"
            _selected={{ borderColor: "white" }}
            fontSize="14px"
          >
            Todos{" "}
            <span
              style={{
                marginLeft: "10px",
                padding: "5px 10px",
                backgroundColor: "#01B0D1",
                borderRadius: "8px",
                fontSize: "12px",
              }}
            >
              {modules.length}
            </span>
          </Tab>
          <Tab
            color="white"
            _selected={{ borderColor: "white" }}
            fontSize="14px"
          >
            Online{" "}
            <span
              style={{
                marginLeft: "10px",
                padding: "5px 10px",
                backgroundColor: "#21BD52",
                borderRadius: "8px",
                fontSize: "12px",
              }}
            >
              {availableModules.length}
            </span>
          </Tab>
          <Tab
            color="white"
            _selected={{ borderColor: "white" }}
            fontSize="14px"
          >
            Offline
            <span
              style={{
                marginLeft: "10px",
                padding: "5px 10px",
                backgroundColor: "#F45031",
                borderRadius: "8px",
                fontSize: "12px",
              }}
            >
              {unavailableModules.length}
            </span>
          </Tab>
        </TabList>

        <TabPanels>
          <TabPanel>
            <ModulesTable
              modules={modules}
              setSelectedId={setSelectedId}
              setSelectedMaquina={setSelectedMaquina}
              setModuleProps={setModuleProps}
              onOpenDeleteModal={onOpenDeleteModal}
              onOpenRemoteCreditModal={onOpenRemoteCreditModal}
              onOpenModalRelatorio={onOpenModalRelatorio}
              onOpenBonusPaymentModal={onOpenBonusPaymentModal}
              onOpenTimerConfigModal={onOpenTimerConfigModal}
              onOpenEditModal={onOpen}
              tabType="allModules"
            />
          </TabPanel>
          <TabPanel>
            <ModulesTable
              modules={availableModules}
              setSelectedId={setSelectedId}
              setSelectedMaquina={setSelectedMaquina}
              setModuleProps={setModuleProps}
              onOpenDeleteModal={onOpenDeleteModal}
              onOpenRemoteCreditModal={onOpenRemoteCreditModal}
              onOpenModalRelatorio={onOpenModalRelatorio}
              onOpenBonusPaymentModal={onOpenBonusPaymentModal}
              onOpenTimerConfigModal={onOpenTimerConfigModal}
              onOpenEditModal={onOpen}
              tabType="availableModules"
            />
          </TabPanel>
          <TabPanel>
            <ModulesTable
              modules={unavailableModules}
              setSelectedId={setSelectedId}
              setSelectedMaquina={setSelectedMaquina}
              setModuleProps={setModuleProps}
              onOpenDeleteModal={onOpenDeleteModal}
              onOpenRemoteCreditModal={onOpenRemoteCreditModal}
              onOpenModalRelatorio={onOpenModalRelatorio}
              onOpenBonusPaymentModal={onOpenBonusPaymentModal}
              onOpenTimerConfigModal={onOpenTimerConfigModal}
              onOpenEditModal={onOpen}
              tabType="unavailableModules"
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
      <ModalModuleEdit
        isOpen={isOpen}
        onClose={onClose}
        moduleProps={moduleProps}
      />
      <DeleteModal
        isOpen={isOpenDeleteModal}
        onClose={onCloseDeleteModal}
        id={selectedId}
      />
      <RemoteCreditModal
        isOpen={isOpenRemoteCreditModal}
        onClose={onCloseRemoteCreditModal}
        id={selectedId}
      />
      <ModalRelatorio
        isOpen={isOpenModalRelatorio}
        onClose={onCloseModalRelatorio}
        selectedId={selectedId}
        maquinasInfo={selectedMaquina}
      />
      <BonusPaymentModule
        isOpen={isOpenBonusPaymentModal}
        onClose={onCloseBonusPaymentModal}
        moduleId={selectedId}
        machineName={selectedMaquina.nome}
      />
      <TimerConfigurationModule
        isOpen={isOpenTimerConfigModal}
        onClose={onCloseTimerConfigModal}
        moduleId={selectedId}
        machineName={selectedMaquina.nome}
      />
    </Flex>
  );
}
